<script setup lang="ts">
import FileBrowser from './FileBrowser.vue';
import Modal from '../modal/Modal.vue';
import { ref } from 'vue';
import {injectEnv} from "@fd/Environment";
import SymIcon from "@fd/helpers/SymIcon.vue";

const props = defineProps({
		restApi: { type: String, required: false, default: "api/files/fileBrowser" },
		styleClass: { type: String, required: false, default: "" },
		disableClientStorage: { type: Boolean, required: false, default: false },
		button: Boolean
	});

const env = injectEnv();
const bundleDoc=env.msg("fileZone.fromDocuments");
const showModal = ref(false);

const emit = defineEmits(['selectFile']);

function selectFile(id: string, name: string, mime: string): void
{
	emit('selectFile',id,name,mime);
}


</script>

<template>
	<button v-if="button" class="sbutton" @click.prevent="showModal = true">
		<sym-icon name="volume"/> <span class="button-text">{{bundleDoc}}</span>
	</button>
	<a v-else href="#" @click.prevent="showModal = true" :class="styleClass"><sym-icon name="volume"/></a>
	
	<Teleport to="body">
		<modal :show="showModal" @close="showModal = false">
			<template #body>
				<file-browser :rest-api="restApi" :disable-client-storage="disableClientStorage"  @select-file="selectFile" @close="showModal = false"/>
			</template>
		</modal>
	</Teleport>
	
</template>